import { arrayOf, shape, string } from 'prop-types'

const MainCategoryType = shape({
  canonicalUrl: string.isRequired,
  name: string.isRequired,
})

export const MainCategoriesType = arrayOf(MainCategoryType.isRequired)
